import type { Nullable } from '../models';

// TODO: remove after codegen regeneration — KATANA-1883 (replace with the generated `CurrencyPrecision` type)
export type CurrencyPrecision = { code: string; decimals: number };

export const DEFAULT_CURRENCY_DECIMALS = 2;

// Intl.NumberFormat accepts 0-100 fraction digits; anything outside that is not a usable precision.
const MAX_CURRENCY_DECIMALS = 100;

let decimalsByCode: Readonly<Record<string, number>> = {};

const isUsablePrecision = (precision: Nullable<CurrencyPrecision>): precision is CurrencyPrecision =>
  !!precision &&
  typeof precision.code === 'string' &&
  Number.isInteger(precision.decimals) &&
  precision.decimals >= 0 &&
  precision.decimals <= MAX_CURRENCY_DECIMALS;

/**
 * Holds the per-currency display precision campaign-gql returns with the grid data. Money formatting
 * reads it from here, so the browser's currency data never decides how many decimals a value shows.
 * A missing list keeps the last one loaded; an unusable entry is skipped and renders with
 * DEFAULT_CURRENCY_DECIMALS like any currency the list does not carry.
 */
export const setCurrencyPrecisions = (precisions?: Nullable<ReadonlyArray<Nullable<CurrencyPrecision>>>): void => {
  if (!precisions) return;

  decimalsByCode = precisions.filter(isUsablePrecision).reduce<Record<string, number>>((byCode, { code, decimals }) => {
    byCode[code] = decimals;
    return byCode;
  }, {});
};

export const getCurrencyDecimals = (code: string): number => decimalsByCode[code] ?? DEFAULT_CURRENCY_DECIMALS;

export const resetCurrencyPrecisions = (): void => {
  decimalsByCode = {};
};
